import { LoadingScreen } from "components/LoadingScreen";
import { Page } from "containers/Page";
import { FiltrosLicenciamento } from "./Containers/Filtros";
import { ListagemSolicitacoesLicenciamento } from "./Containers/ListagemSolicitacoesLicenciamento";
import { useEffect, useState } from "react";
import { useSolicitacaoLicenciamentos } from "hooks/useSolicitacaoLicenciamentos";
import { ModalEmitirLicenciamento } from "./Containers/ModalEmitirLicenciamento";
import { useEmpresas } from "hooks/useEmpresas";
import { IDadosEmitirLicenciamento } from "./Interfaces/IDadosEmitirLicenciamento";
import { DadosLoteLicenciamento } from "./Containers/DadosLoteLicenciamento";
import { FiltrosProcessosLoteLicenciamento } from "./Containers/FiltrosProcessosLoteLicenciamento";
import { ListagemLoteLicenciamento } from "./Containers/ListagemLoteLicenciamento";
import { IProcessoCriarLoteLicenciamentos } from "./Interfaces/IProcessoCriarLoteLicenciamentos";
import { ListaProcessosVincularLoteLicenciamentos } from "./Containers/ListagemProcessosVincular";

export function Licenciamento() {
  const [pagina, setPagina] = useState<"emissao" | "resumo" | "processos">(
    "emissao",
  );
  const { empresasOptions } = useEmpresas();
  const {
    listarSolicitacoesLicenciamento,
    setFiltros,
    loading,
    solicitacoes,
    totalRows,
    setLimit,
    setPage,
    limit,
    selectedRows,
    setSelectedRows,
    clearRows,
    setClearRows,
    selectedRowsRemover,
    setSelectedRowsRemover,
    processosVincularLote,
    listarProcessosVincularLote,
    setProcessosVincularLote,
    salvarLote,
  } = useSolicitacaoLicenciamentos();

  useEffect(() => {
    listarSolicitacoesLicenciamento();
  }, [listarSolicitacoesLicenciamento]);

  function handleLimitChange(limit: number) {
    setLimit(limit);
  }

  function handlePageChange(page: number) {
    setPage(page);
  }

  const [showModalEmitirLicenciamento, setShowModalEmitirLicenciamento] =
    useState<boolean>(false);

  const defaultDadosEmitir: IDadosEmitirLicenciamento = {
    cobrar: "SIM",
    idEmpresa: 0,
    uf: "",
    exercicio: 0,
    descricao: "",
  };
  const [dadosEmitir, setDadosEmitir] = useState<IDadosEmitirLicenciamento>({
    ...defaultDadosEmitir,
  });

  const onSubmitModalEmitirLicenciamento = () => {
    setPagina("resumo");
    setShowModalEmitirLicenciamento(false);
  };

  const onClickEscolherProcessos = () => {
    setPagina("processos");
  };

  const onClickCancelarEscolherProcessos = () => {
    setPagina("resumo");
  };

  const onClickSalvarLote = async () => {
    const { data } = await salvarLote({ ...dadosEmitir, processos });

    if (data) {
      window.location.href = "/app/backoffice/licenciamento";
    }
  };

  const [processos, setProcessos] = useState<
    IProcessoCriarLoteLicenciamentos[]
  >([]);

  useEffect(() => {
    setProcessosVincularLote([]);
  }, [pagina]);

  const onSubmitAddProcessos = () => {
    setPagina("resumo");
    setProcessos((processosAtuais) => [
      ...processosAtuais,
      ...selectedRows
        .filter(
          (row) =>
            !processosAtuais.some(
              (processo) => processo.idProcesso === row.idProcesso,
            ),
        )
        .map((row) => {
          const dadosProcesso = processosVincularLote.find(
            (processo) => processo.idProcesso === row.idProcesso,
          );
          return {
            idProcesso: row.idProcesso,
            placa: dadosProcesso?.placa ? dadosProcesso?.placa : null,
            renavam: dadosProcesso?.renavam ? dadosProcesso?.renavam : null,
            chassi: dadosProcesso?.chassi ? dadosProcesso?.chassi : null,
            uf: dadosProcesso?.uf ? dadosProcesso?.uf : null,
            servicoProcesso: dadosProcesso?.servicoProcesso
              ? dadosProcesso?.servicoProcesso
              : null,
          };
        }),
    ]);
  };

  return (
    <Page title="Emitir licenciamentos">
      <LoadingScreen mostrar={loading} />
      {pagina === "emissao" && (
        <div>
          <FiltrosLicenciamento
            handleSubmitFiltros={setFiltros}
            empresasOptions={empresasOptions}
            onClickEmitir={() => setShowModalEmitirLicenciamento(true)}
          />
          <ListagemSolicitacoesLicenciamento
            loading={loading}
            dados={solicitacoes}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleLimitChange}
            rowsPerPage={limit}
            totalRows={totalRows}
            listarSolicitacoesLicenciamento={listarSolicitacoesLicenciamento}
          />
          <ModalEmitirLicenciamento
            showModal={showModalEmitirLicenciamento}
            handleCloseModal={() => setShowModalEmitirLicenciamento(false)}
            onSubmit={onSubmitModalEmitirLicenciamento}
            empresasOptions={empresasOptions}
            defaultDadosEmitir={defaultDadosEmitir}
            dadosEmitir={dadosEmitir}
            setDadosEmitir={setDadosEmitir}
          />
        </div>
      )}
      {pagina === "resumo" && (
        <div>
          <DadosLoteLicenciamento
            empresasOptions={empresasOptions}
            dadosEmitir={dadosEmitir}
            setDadosEmitir={setDadosEmitir}
            onClickEscolherProcessos={onClickEscolherProcessos}
            processos={processos}
            onClickSalvarLote={onClickSalvarLote}
          />
          <ListagemLoteLicenciamento
            clearRows={clearRows}
            setRowsSelected={setSelectedRowsRemover}
            setProcessos={setProcessos}
            processos={processos}
            selectedRows={selectedRowsRemover}
            tela={pagina}
          />
        </div>
      )}
      {pagina === "processos" && (
        <div>
          <FiltrosProcessosLoteLicenciamento
            onClickCancelar={onClickCancelarEscolherProcessos}
            onSubmit={listarProcessosVincularLote}
            habilitarCancelar={!!processos.length}
            idEmpresa={dadosEmitir.idEmpresa}
          />
          <ListaProcessosVincularLoteLicenciamentos
            clearRows={clearRows}
            setRowsSelected={setSelectedRows}
            selectedRows={selectedRows}
            tela={pagina}
            onClickAddProcesso={onSubmitAddProcessos}
            dados={processosVincularLote}
          />
        </div>
      )}
    </Page>
  );
}
